import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_NullableBooleanAdapter3vvq2rksy333a as get_NullableBooleanAdapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Data3pzhqfxhg1ap1 as Data } from '../GrantDiscordAccessMutation.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data_0() {
  if (DataClass === VOID) {
    class $ {
      constructor() {
        Data_instance = this;
        this.c6j_1 = listOf('grantDiscordAccess');
      }
      e40(reader, customScalarAdapters) {
        var _grantDiscordAccess = null;
        $l$loop: while (true) {
          if (reader.w4c(this.c6j_1) === 0)
            _grantDiscordAccess = get_NullableBooleanAdapter().e40(reader, customScalarAdapters);
          else
            break $l$loop;
        }
        return new (Data())(_grantDiscordAccess);
      }
      d6j(writer, customScalarAdapters, value) {
        writer.h48('grantDiscordAccess');
        get_NullableBooleanAdapter().j40(writer, customScalarAdapters, value.v6g_1);
      }
      f40(writer, customScalarAdapters, value) {
        return this.d6j(writer, customScalarAdapters, value instanceof Data() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Data', VOID, VOID, [Adapter()]);
    DataClass = $;
  }
  return DataClass;
}
var Data_instance;
function Data_getInstance() {
  if (Data_instance === VOID)
    new (Data_0())();
  return Data_instance;
}
//region block: exports
export {
  Data_getInstance as Data_getInstance319j5in8e6yr5,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutation_ResponseAdapter.mjs.map
